import { render, staticRenderFns } from "./share.vue?vue&type=template&id=58387fb6&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58387fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58387fb6')) {
      api.createRecord('58387fb6', component.options)
    } else {
      api.reload('58387fb6', component.options)
    }
    module.hot.accept("./share.vue?vue&type=template&id=58387fb6&scoped=true", function () {
      api.rerender('58387fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/share.vue"
export default component.exports